import { render } from "./bulk.vue?vue&type=template&id=5a8c0d04&ts=true"
import script from "./bulk.vue?vue&type=script&lang=ts&config=true"
export * from "./bulk.vue?vue&type=script&lang=ts&config=true"

import "./bulk.vue?vue&type=style&index=0&id=5a8c0d04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__